import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { enumHtsLineStatus } from '../../enums';

/** "Validated" / "Passes without a code" / "Needs classification" chip with the reason in a tooltip (#13384). */
@Component({
  selector: 'app-hts-line-status-chip',
  templateUrl: './hts-line-status-chip.component.html',
  styleUrls: ['./hts-line-status-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HtsLineStatusChipComponent {
  @Input() public status: enumHtsLineStatus = enumHtsLineStatus.NeedsClassification;
  @Input() public reasonKey: string | null = null;
  @Input() public reasonParams: { [key: string]: string | number } | null = null;

  public get isValidated(): boolean {
    return this.status === enumHtsLineStatus.Validated;
  }

  public get isPasses(): boolean {
    return this.status === enumHtsLineStatus.PassesWithoutCode;
  }

  public get isNeeds(): boolean {
    return !this.isValidated && !this.isPasses;
  }

  public get labelKey(): string {
    if (this.isValidated) {
      return 'HTS_ASSISTANT.STATUS_VALIDATED';
    }
    return this.isPasses ? 'HTS_ASSISTANT.STATUS_PASSES' : 'HTS_ASSISTANT.STATUS_NEEDS_CLASSIFICATION';
  }

  public get isShowReason(): boolean {
    return !!this.reasonKey;
  }
}
